export type GameConfig = {
    timeBetweenRounds: number;
    chanceIncrementAmount: number;
    chanceMultiplierAmount: number;
    chanceInitialAmount: number;
    maxProbability: number;
    rewardsPercentage: number;
    operationsPercentage: number;
    nextPotPercentage: number;
    parentGamePercentage: number;
    hasParent: boolean;
    ignoreOdds: boolean;
    numAllocs: readonly number[];
}

export const DEFAULT_GAME_CONFIG: GameConfig = {
    timeBetweenRounds: 0,
    chanceIncrementAmount: 0,
    chanceMultiplierAmount: 0,
    chanceInitialAmount: 0,
    maxProbability: 0,
    rewardsPercentage: 0,
    operationsPercentage: 0,
    nextPotPercentage: 0,
    parentGamePercentage: 0,
    hasParent: false,
    ignoreOdds: false,
    numAllocs: [],
} as const